module.exports = {

    //标题
    title: '数据智能服务平台',

    /**
     * 是否系统布局配置
     */
    showSettings: false,

    /**
     * 是否显示 tagsView
     */
    tagsView: true,

    /**
     * 是否固定头部
     */
    fixedHeader: true,

    /**
     * 是否显示logo
     */
    sidebarLogo: true,

    /** 菜单列表*/
    menuList: [
    ]

}
